import Vue from 'vue';
import { Backend } from '@/_axios';
// import mutations from './mutations'
// import actions from './actions'
// import moment from 'moment';

export const LOAD_CONFIGURATIONS = 'LOAD_CONFIGURATIONS';
export const SET_CONFIGURATIONS = 'SET_CONFIGURATIONS';

export const SET_CONFIGURATION = 'SET_CONFIGURATION';

const state = {
  configurations: {},
};

const getters = {
  configurations(state) {
    return state.configurations;
  }
};

const actions = {
  [LOAD_CONFIGURATIONS]: function ({ commit }) {
    Backend.get('/api/configurations').then((response) => {
      const configurations = {};
      // console.log(response.data);
      response.data.forEach((config) => {
        configurations[config.key] = config.value;
      });
      commit('SET_CONFIGURATIONS', { data: configurations });
    });
  },
  [SET_CONFIGURATION]: function ({ commit }, { key, value }) {
    Backend.post('/api/configuration', { key: key, value: value }).then((response) => {
      commit('SET_CONFIGURATION', { data: response.data });
    });
  }
};

const mutations = {
  [SET_CONFIGURATIONS]: function (state, { data }) {
    // Vue.set(state, 'configurations', data);
    state.configurations = data;
  },
  [SET_CONFIGURATION]: function (state, { data }) {
    Vue.set(state.configurations, data.key, data.value);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
